module.exports = __webpack_public_path__ + "img/icon-profile.6cb7bd79.svg";